"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerConfigurationSchema = void 0;
var _zod = require("zod");
var _LoggerTransportType = require("./types/LoggerTransportType");
var _SeverityLevels = require("./types/SeverityLevels");
const zodRegexOrRegexpLikeString = _zod.z.custom(data => {
  if (!data) {
    return false;
  }
  const hasValidData = data instanceof RegExp || typeof data === 'string';
  return hasValidData ? data : undefined;
}).transform(value => typeof value === 'string' ? new RegExp(value, 'i') : value);
const severityLevelKeys = Object.keys(_SeverityLevels.SeverityLevels).filter(value => !/\d+/.test(value));
const severityLevelValues = Object.values(_SeverityLevels.SeverityLevels).filter(value => typeof value === 'number');
const allowedSeverityOptions = new Set([...severityLevelValues, ...severityLevelKeys, ...severityLevelKeys.map(value => value.toLowerCase())]);
/** This allows severityLevel to be either in number, UPPER_CASE or lowercase */
const zodCoerceSeverityLevel = _zod.z.custom(value => {
  if (!value) {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- type is not important here
  return allowedSeverityOptions.has(value);
}).transform(value => typeof value === 'number' ? value : _SeverityLevels.SeverityLevels[value.toUpperCase()]);
const loggerConfigurationFilterSchema = _zod.z.object({
  /**
   * Logger name exact match filter
   */
  byName: _zod.z.string().optional(),
  /**
   * Logger area name exact match filter
   */
  byAreaName: _zod.z.string().optional(),
  /**
   * Logger regexp name filter. It can be RegExp or string that will be converted to RegExp
   */
  byNameRegExp: zodRegexOrRegexpLikeString.optional(),
  /**
   * Logger regexp area name filter. It can be RegExp or string that will be converted to RegExp
   */
  byAreaNameRegExp: zodRegexOrRegexpLikeString.optional(),
  /**
   * Logger transport type filter
   */
  byTransportType: _zod.z.nativeEnum(_LoggerTransportType.LoggerTransportType).optional(),
  /** Minimal severity level type filter */
  byMinimalSeverityLevel: zodCoerceSeverityLevel.optional(),
  /** If current group has enabled logging, if false then logging is disabled for matches */
  enabled: _zod.z.coerce.boolean()
});

// IMPORTANT: Default values are defined in constants.ts, this schema does not enforce it.
// Enforcing is crutial for merging configurations (Node.js->browser for example)
const loggerConfigurationSchema = exports.loggerConfigurationSchema = _zod.z.object({
  /**
   * Controls if logging is enabled globally. If false then nothing is logged and filters are ignored!
   * @default true
   */
  enabled: _zod.z.coerce.boolean().optional(),
  /**
   * Controls default minimal severity levels for logging. Can be overriden with filters array
   * @default process.env.NODE_ENV === 'production' ? SeverityLevels.METRIC : SeverityLevels.DEBUG
   */
  minimalSeverityLevel: zodCoerceSeverityLevel.optional(),
  /** Rule groups. These groups have their own filters and if they match then specific configurations are applied. Last to match is applied */
  filters: _zod.z.array(loggerConfigurationFilterSchema).optional().default([])
});

/** Input type for the {@link LoggerConfiguration} type  */
//# sourceMappingURL=loggerConfigurationSchema.js.map